module.exports = __webpack_public_path__ + "img/hero-phone.de497f09.png";